<div>
  <div class="form-section">
    <div class="row">
      <div class="col-4">
        <div class="form-group">
          <label for="subject_type" class="required">Subject Type</label>
          <select type="text" class="form-control" id="subject_type" [formControl]="selectedSubjectType" (change)="onChangeSubjectType()">
            <option value="">Select</option>
            <option [value]="type.value" *ngFor="let type of subjectTypes">{{ type.name }}</option>
          </select>
        </div>
      </div>
    </div>


    <ng-container *ngIf="selectedSubjectType.value == 'insured'">
      <form [formGroup]="insuredForm">
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="business_name" class="required">Business Name</label>
              <input type="text" class="form-control" id="business_name" formControlName="business_name"/>
            </div>
          </div>

          <div class="col-4">
            <div class="form-group">
              <label for="first_name" class="required">First Name</label>
              <input type="text" class="form-control" id="first_name" formControlName="first_name"/>
            </div>
          </div>

          <div class="col-4">
            <div class="form-group">
              <label for="middle_name">Middle Name</label>
              <input type="text" class="form-control" id="middle_name" formControlName="middle_name"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="last_name" class="required">Last Name</label>
              <input type="text" class="form-control" id="last_name" formControlName="last_name"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="suffix">Suffix</label>
              <select type="text" class="form-control" id="suffix" formControlName="suffix">
                <option value="">Select Suffix</option>
                <option value="Jr.">Jr.</option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="aka">AKA</label>
              <input type="text" class="form-control" id="aka" formControlName="aka"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="address">Address</label>
              <input type="text" class="form-control" id="address" formControlName="address_1"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="city">City</label>
              <input type="text" class="form-control" id="city" formControlName="city"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="state">State</label>
              <select type="text" class="form-control" id="state" formControlName="state">
                <option value="">Select State</option>
                <option [value]="state.name" *ngFor="let state of states$ | async">{{ state.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="main_number">Main #</label>
              <input type="text" class="form-control" id="main_number" formControlName="main_phone_number" mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="cell">Cell #</label>
              <input type="number" class="form-control" id="cell" formControlName="cell_phone_number" mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="dob">DOB</label>
              <input type="text" class="form-control" id="dob"  jDate [formCtrl]="insuredForm.get('dob')" [meta]="{maxDate: 'today'}"/>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="ssn">SSN</label>
              <input type="text" class="form-control" id="ssn" formControlName="ssn" mask="000-00-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
        </div>
      </form>

    </ng-container>

    <ng-container *ngIf="selectedSubjectType.value == 'claimant'">
      <form [formGroup]="claimantForm">
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="first_name" class="required">First Name</label>
              <input type="text" class="form-control" id="first_name" formControlName="first_name"/>
            </div>
          </div>

          <div class="col-4">
            <div class="form-group">
              <label for="middle_name">Middle Name</label>
              <input type="text" class="form-control" id="middle_name" formControlName="middle_name"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="last_name" class="required">Last Name</label>
              <input type="text" class="form-control" id="last_name" formControlName="last_name"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="suffix">Suffix</label>
              <select type="text" class="form-control" id="suffix" formControlName="suffix">
                <option value="">Select Suffix</option>
                <option value="Jr.">Jr.</option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="aka">AKA</label>
              <input type="text" class="form-control" id="aka" formControlName="aka"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="address">Address</label>
              <input type="text" class="form-control" id="address" formControlName="address_1"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="city">City</label>
              <input type="text" class="form-control" id="city" formControlName="city"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="state">State</label>
              <select type="text" class="form-control" id="state" formControlName="state">
                <option value="">Select State</option>
                <option [value]="state.name" *ngFor="let state of states$ | async">{{ state.name }}</option>
              </select>
            </div>
          </div>

          <div class="col-4">
            <div class="form-group">
              <label for="zip">Zip</label>
              <input type="number" class="form-control" id="zip" formControlName="zip" mask="00000"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="home_number">Home #</label>
              <input type="number" class="form-control" id="home_number" formControlName="home_phone_number" mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="cell">Cell #</label>
              <input type="number" class="form-control" id="cell" formControlName="cell_phone_number"   mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="business_number">Business #</label>
              <input type="number" class="form-control" id="business_number" formControlName="business_phone_number" mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="dob">DOB</label>
              <input type="text" class="form-control" id="dob"  jDate [formCtrl]="claimantForm.get('dob')" [meta]="{maxDate: 'today'}"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="ssn">SSN</label>
              <input type="text" class="form-control" id="ssn" formControlName="ssn" mask="000-00-0000"/>
            </div>
          </div>
        </div>
      </form>

    </ng-container>

    <ng-container *ngIf="selectedSubjectType.value == 'defense_attorney' || selectedSubjectType.value == 'applicant_party_attorney'">
      <form [formGroup]="defenseAttorneyApplicantForm">
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="firm_name" class="required">Firm name</label>
              <input type="text" class="form-control" id="firm_name" formControlName="firm_name"/>
            </div>
          </div>

          <div class="col-4">
            <div class="form-group">
              <label for="first_name" class="required">First Name</label>
              <input type="text" class="form-control" id="first_name" formControlName="first_name"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="middle_name">Middle Name</label>
              <input type="text" class="form-control" id="middle_name" formControlName="middle_name"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="last_name" class="required">Last Name</label>
              <input type="text" class="form-control" id="last_name" formControlName="last_name"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="suffix">Suffix</label>
              <input type="text" class="form-control" id="suffix" formControlName="suffix"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="aka">AKA</label>
              <input type="text" class="form-control" id="aka" formControlName="aka"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="address">Address</label>
              <input type="text" class="form-control" id="address" formControlName="address_1"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="city">City</label>
              <input type="text" class="form-control" id="city" formControlName="city"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="state">State</label>
              <select type="text" class="form-control" id="state" formControlName="state">
                <option value="">Select State</option>
                <option [value]="state.name" *ngFor="let state of states$ | async">{{ state.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="zip_code">Zip Code</label>
              <input type="number" class="form-control" id="zip_code" formControlName="zip_code" mask="00000"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="business_number">Business #</label>
              <input type="number" class="form-control" id="business_number" formControlName="business_phone_number" mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="cell">Cell #</label>
              <input type="text" class="form-control" id="cell" formControlName="cell_phone_number" mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
        </div>
      </form>

    </ng-container>

    <ng-container *ngIf="selectedSubjectType.value == 'co_defendant'">
      <form [formGroup]="coDefendantForm">
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="role" class="required">Role</label>
              <input type="text" class="form-control" id="role" formControlName="role"/>
            </div>
          </div>

          <div class="col-4">
            <div class="form-group">
              <label for="company_name" class="required">Company Name</label>
              <input type="text" class="form-control" id="company_name" formControlName="company_name"/>
            </div>
          </div>

          <div class="col-4">
            <div class="form-group">
              <label for="first_name" class="required">First Name</label>
              <input type="text" class="form-control" id="first_name" formControlName="first_name"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="middle_name">Middle Name</label>
              <input type="text" class="form-control" id="middle_name" formControlName="middle_name"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="last_name">Last Name</label>
              <input type="text" class="form-control" id="last_name" formControlName="last_name"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="suffix">Suffix</label>
              <input type="text" class="form-control" id="suffix" formControlName="suffix"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="aka">AKA</label>
              <input type="text" class="form-control" id="aka" formControlName="aka"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="address">Address</label>
              <input type="text" class="form-control" id="address" formControlName="address_1"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="city">City</label>
              <input type="text" class="form-control" id="city" formControlName="city"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="state">State</label>
              <select type="text" class="form-control" id="state" formControlName="state">
                <option value="">Select State</option>
                <option [value]="state.name" *ngFor="let state of states$ | async">{{ state.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="zip_code">Zip Code</label>
              <input type="number" class="form-control" id="zip_code" formControlName="zip_code" mask="00000"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="home">Home #</label>
              <input type="text" class="form-control" id="home" formControlName="home_phone_number" mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="cell">Cell #</label>
              <input type="text" class="form-control" id="cell" formControlName="cell_phone_number" mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="business_number">Business #</label>
              <input type="number" class="form-control" id="business_number" formControlName="business_phone_number" mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-container *ngIf="selectedSubjectType.value == 'other'">
      <form [formGroup]="otherForm">
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="role" class="required">Role</label>
              <input type="text" class="form-control" id="role" formControlName="role"/>
            </div>
          </div>

          <div class="col-4">
            <div class="form-group">
              <label for="first_name" class="required">First Name</label>
              <input type="text" class="form-control" id="first_name" formControlName="first_name"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="middle_name">Middle Name</label>
              <input type="text" class="form-control" id="middle_name" formControlName="middle_name"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="last_name" class="required">Last Name</label>
              <input type="text" class="form-control" id="last_name" formControlName="last_name"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="suffix">Suffix</label>
              <input type="text" class="form-control" id="suffix" formControlName="suffix"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="aka">AKA</label>
              <input type="text" class="form-control" id="aka" formControlName="aka"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="address">Address</label>
              <input type="text" class="form-control" id="address" formControlName="address_1"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="city">City</label>
              <input type="text" class="form-control" id="city" formControlName="city"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="state">State</label>
              <select type="text" class="form-control" id="state" formControlName="state">
                <option value="">Select State</option>
                <option [value]="state.name" *ngFor="let state of states$ | async">{{ state.name }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="zip_code">Zip Code</label>
              <input type="number" class="form-control" id="zip_code" formControlName="zip_code" mask="00000"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="home">Home #</label>
              <input type="text" class="form-control" id="home" formControlName="home_phone_number" mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="cell">Cell #</label>
              <input type="text" class="form-control" id="cell" formControlName="cell_phone_number" mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="business_number">Business #</label>
              <input type="number" class="form-control" id="business_number" formControlName="business_phone_number" mask="000-000-0000" [dropSpecialCharacters]="false"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="dob">DOB</label>
              <input type="text" class="form-control" id="dob" jDate [formCtrl]="otherForm.get('dob')" [meta]="{maxDate: 'today'}"/>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="ssn">SSN</label>
              <input type="text" class="form-control" id="ssn" formControlName="ssn" mask="000-00-0000"/>
            </div>
          </div>
        </div>
      </form>
    </ng-container>

    <div class="row">
      <div class="col-12 mt-4 d-flex justify-content-between">
      <button class="btn text-dark-orange btn-link btn-md mr-1 text-decoration-none" (click)="addNewSubject()">Add New Subject</button>
        <div>
          <button type="button" class="btn btn-outline-secondary btn-sm text-dark mr-1">
            Cancel
          </button>
          <button type="button" class="btn btn-outline-primary btn-sm text-primary mr-1" (click)="saveSubject()">
            {{ editSubjectIndex || editSubjectIndex == 0 ? 'Update' : 'Save' }}
          </button>
          <button type="button" class="btn spear-button-background btn-sm text-white" (click)="onSubmitForm()">
            Save & Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>